import { MessageCircle } from "lucide-react";

export default function WhatsAppFAB() {
  const openWhats = () => {
    window.open(
      "https://wa.me/5511980331231?text=Ol%C3%A1%20David%2C%20quero%20conversar%20sobre%20consultoria%20em%20TI.",
      "_blank"
    );
  };

  return (
    <button
      onClick={openWhats}
      className="fixed bottom-6 left-6 z-40 w-14 h-14 rounded-full bg-[#25D366] text-white flex items-center justify-center shadow-[0_10px_40px_rgba(37,211,102,0.55)] hover:scale-110 transition-transform pulse-glow"
      aria-label="WhatsApp"
      data-testid="whatsapp-fab"
    >
      <MessageCircle size={24} fill="currentColor" />
    </button>
  );
}
